module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result",
    class: [_vm.isSpecialCard ? 'specialRace' : '', _vm.isWin ? 'win' : 'lose']
  }, [_c('vue-audio', {
    ref: "resultWin",
    attrs: {
      "file": 10
    }
  }), _vm._v(" "), _c('vue-audio', {
    ref: "resultLose",
    attrs: {
      "file": 11
    }
  }), _vm._v(" "), _c('vue-audio', {
    ref: "btnClick",
    attrs: {
      "file": 3
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "result__list"
  }, [_c('li', {
    class: _vm.colorHorse
  }), _vm._v(" "), _c('li', {
    staticClass: "result__item"
  }, [(_vm.isWin) ? _c('p', {
    staticClass: "result__message",
    class: _vm.result
  }, [_c('img', {
    attrs: {
      "src": require("../assets/image/txt_win.png"),
      "alt": "you win"
    }
  })]) : _c('p', {
    staticClass: "result__message",
    class: _vm.result
  }, [_c('img', {
    attrs: {
      "src": require("../assets/image/txt_lose.png"),
      "alt": "you-lose"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "result__list--sm"
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isSpecialCard),
      expression: "!isSpecialCard"
    }],
    staticClass: "result__row"
  }, [_c('button', {
    staticClass: "result__button",
    on: {
      "click": function($event) {
        _vm.showModal('specialCard')
      }
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('p', [_c('button', {
    on: {
      "click": function($event) {
        _vm.showModal('specialCardInfo')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/image/txt_result_crispr_info.png"),
      "alt": "CRISPR-CAS カードとは"
    }
  })])])]), _vm._v(" "), _c('li', {
    staticClass: "result__row"
  }, [_c('button', {
    staticClass: "result__button",
    on: {
      "click": function($event) {
        _vm.showModal('race')
      }
    }
  }, [_vm._m(1)])]), _vm._v(" "), _c('li', {
    staticClass: "result__row"
  }, [_c('button', {
    staticClass: "result__button",
    on: {
      "click": function($event) {
        _vm.showModal('card')
      }
    }
  }, [_vm._m(2)])]), _vm._v(" "), _c('li', {
    staticClass: "result__row"
  }, [_c('button', {
    staticClass: "result__button",
    on: {
      "click": function($event) {
        _vm.showModal('close')
      }
    }
  }, [_vm._m(3)])])])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "id": _vm.key,
      "show": _vm.isModal,
      "type": _vm.typeName
    },
    on: {
      "update:show": function($event) {
        _vm.isModal = $event
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": require("../assets/image/txt_result_crispr.png"),
      "alt": "ゲノムカード１枚をCRISPR-CASカードに変えてもう一度やる"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": require("../assets/image/txt_result_race.png"),
      "alt": "同じゲノムカードでもう一度やる"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": require("../assets/image/txt_result_card.png"),
      "alt": "最初からやる"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": require("../assets/image/txt_result_close.png"),
      "alt": "終わる"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55dbd715","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Result.vue
// module id = 78
// module chunks = 0